import { Bounds, Point } from "../space/bounds";
import { RDisplay } from "../../ui/RotDisplay";

export enum TileVisibility {
  VISIBLE,
  SEEN,
  HIDDEN,
}

export class WorldTile<T> {
  seen = false;
  room = -1;
  z = 0;

  constructor(public type: T) {}
}

export type DrawTileFn<T> = (
  display: RDisplay,
  x: number,
  y: number,
  tile: WorldTile<T>,
  visibility: TileVisibility
) => void;

export class LevelMap<T> {
  tiles: WorldTile<T>[];
  constructor(
    public drawTile: DrawTileFn<T>,
    public width: number,
    public height: number
  ) {
    this.tiles = [];
  }

  tile(p: Point) {
    return this.tiles[p.x + p.y * this.width];
  }

  tileAt(x: number, y: number) {
    return this.tiles[x + y * this.width];
  }

  inBounds(x: number, y: number) {
    return 0 <= x && x < this.width && 0 <= y && y < this.height;
  }

  draw(display: RDisplay, bounds: Bounds, view: Bounds) {
    for (let y = view.y; y < view.h + view.y; y++) {
      for (let x = view.x; x < view.w + view.x; x++) {
        const t = this.tiles[y * this.width + x];
        t &&
          this.drawTile(
            display,
            x + bounds.x - view.x,
            y + bounds.y - view.y,
            t,
            TileVisibility.VISIBLE
          );

        /**const dMapVal = gameData.dMapPlayer?.get({ x: x, y: y });
        if (dMapVal) {
          const dString = dMapVal.toString(16);
          display.drawAppend(
            x + bounds.x - view.x,
            y + bounds.y - view.y,
            dString[dString.length - 1],
            "#FFFFFF",
            "transparent"
          );
        }**/
      }
    }
  }

  fillAll(makeFillTile: () => WorldTile<T>) {
    this.tiles = [];
    const size = this.height * this.width;
    for (let i = 0; i < size; i++) {
      this.tiles.push(makeFillTile());
    }
  }
}
